<template>
	<div>
		<!-- 2FA Required Overlay -->
		<div v-if="mustSetupTwoFactor" class="fixed inset-0 bg-black/50 z-50"></div>

		<Sidenav/>

		<main :class="['lg:pl-72 h-screen flex flex-col', { 'overflow-hidden': !isConfigRequestShow }]">
			<router-view></router-view>
		</main>

		<!-- 2FA Setup Modal -->
		<UserAccountDialog ref="userAccountDialog" @on-confirm="onTwoFactorSetupComplete" />
	</div>
</template>

<script>
import Sidenav from "@/Components/Sidenav.vue";
import UserAccountDialog from "@/Dialogs/UserAccountDialog.vue";
import { useAuthStore } from "@/stores/auth.js";
import { mapStores } from "pinia";

export default {
	name: "AuthenticatedLayout",
	components: {Sidenav, UserAccountDialog},
	computed: {
		...mapStores(useAuthStore),
		isConfigRequestShow() {
			return this.$route.name === 'admin.config-requests.show';
		},
		mustSetupTwoFactor() {
			return this.authStore.user?.must_setup_two_factor;
		}
	},
	watch: {
		mustSetupTwoFactor: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.openTwoFactorSetup();
					});
				}
			}
		}
	},
	methods: {
		async openTwoFactorSetup() {
			if (this.$refs.userAccountDialog) {
				await this.$refs.userAccountDialog.open();
				// Set to 2FA tab (index 2)
				this.$refs.userAccountDialog.activeTabIndex = 2;
			}
		},
		async onTwoFactorSetupComplete() {
			// Refresh user data to check if 2FA is now enabled
			await this.authStore.fetchUser();
		}
	},
	beforeRouteEnter: async (to, from, next) => {
		const authStore = useAuthStore();
		try {
			await authStore.fetchUser();
			next();
		} catch (e) {
			console.log(e);
			next({name: 'login'});
		}
	},
}
</script>

<style>
@media(max-width: 1023px) {
  .h-screen {
    max-height: calc(100vh - 56px);
  }
}
</style>